import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class MaterialDashboardService {
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  baseURL_2 = 'https://localhost:44386/api';

  constructor(private http: HttpClient) { }

  ViewStudentCount(YearCode: number, ShiftId: number, CsCode1: number, CsCode2: number): Promise<any> {
    return this.http.get(this.baseURL + '/ViewsStudentCount?YearCode=' + YearCode + '&&ShiftId=' + ShiftId + '&&CsCode1=' + CsCode1 + '&&CsCode2=' + CsCode2)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  GetDataForDashboardPieChart(YearCode: number, ShiftId: number): Promise<any> {
    return this.http.get(this.baseURL + '/GetDataForDashboardPieChart?YearCode=' + YearCode + '&&ShiftId=' + ShiftId)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  GetMonthHeadWiseBarChart(YearCode: number, ShiftId: number): Promise<any> {
    return this.http.get(this.baseURL + '/GetMonthHeadWiseBarChart?YearCode=' + YearCode + '&&ShiftId=' + ShiftId)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  ViewAmountReceivedMonthWise(YearCode: number, ShiftId: number): Promise<any> {
    return this.http.get(this.baseURL + '/ViewAmountReceivedMonthWise?YearCode=' + YearCode + '&&ShiftId=' + ShiftId)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  GetPaymodeFeeReceived(ShiftId: number, Yearcode: number, PMode: string): Promise<any> {
    sessionStorage.setItem('FirstInt', (parseInt(sessionStorage.getItem('FirstInt')) + 1).toString());
    return this.http.get<any>(this.baseURL + '/GetPaymodeFeeReceived?ShiftId=' + ShiftId + '&&YearCode=' + Yearcode + '&&PMode=' + PMode)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  GetPaymodeFeeReceivedTT(ShiftId: number, Yearcode: number, PMode: string): Promise<any> {
    debugger;
    sessionStorage.setItem('FirstInt', (parseInt(sessionStorage.getItem('FirstInt')) + 1).toString());
    return this.http.get<any>(this.baseURL + '/GetPaymodeFeeReceivedTT?ShiftId=' + ShiftId + '&&YearCode=' + Yearcode + '&&PMode=' + PMode)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  ViewStudFeeDetailsDetAllSumChart(YearCode: number, ShiftId: number): Promise<any> {
    return this.http.get(this.baseURL + '/ViewStudFeeDetailsDetAllSumChart?YearCode=' + YearCode + '&&ShiftId=' + ShiftId)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  ViewCOUNTSEXMFGet(YearCode: number, ShiftId: number, CheckId: number): Promise<any> {
    return this.http.get(this.baseURL + '/ViewCOUNTSEXMFGet?YearCode=' + YearCode + '&&ShiftId=' + ShiftId + '&&CheckId=' + CheckId)
      .pipe(retry(1), catchError(this.handleError)).toPromise();
  }

  

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }  
}
